import type { TablePaginationConfig } from "antd";

/**
 * Shared Ant Design Table pagination UX (Orders parity).
 * Mobile: compact pager via tokens.css + showLessItems/responsive.
 */
export const TABLE_PAGINATION_UX: Pick<
  TablePaginationConfig,
  "size" | "showLessItems" | "responsive" | "showSizeChanger" | "pageSizeOptions"
> = {
  size: "small",
  showLessItems: true,
  responsive: true,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "50", "100"],
};
